const b2bApi = {
    CreateCertificate: {
        //生成凭证
        method: "post",
        module: "b2b",
        address: "CustomerBill/CreateCertificate"
    },
    GetSupplierList: {
        // 获取供应商列表
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetSupplierList"
    },
    upload: {
        // 获取个人中心信息
        method: "post",
        module: "b2b",
        address: "qiniu/uploadfile"
    },
    login: {
        // 登陆
        method: "post",
        module: "b2b",
        address: "Customer/LoginV2"
    },
    register: {
        // 注册
        method: "post",
        module: "b2b",
        address: "Customer/HouseKeeperRegister"
    },
    SecurityCode: {
        // 获取图形验证码
        method: "post",
        module: "b2b",
        address: "File/SecurityCode"
    },
    SendTravelVerificationCode: {
        // 校验图形验证码
        method: "post",
        module: "b2b",
        address: "Common/SendTravelVerificationCode"
    },
    sendSmsCode: {
        // 发送验证码
        method: "post",
        module: "b2b",
        address: "Common/SendVerificationCode"
    },
    CheckPhoneIsRegister: {
        // 忘记密码验证手机号
        method: "post",
        module: "b2b",
        address: "Customer/CheckPhoneIsRegister"
    },
    GetFlightListV2: {
        method: "post",
        module: "b2b",
        address: "Flight/GetFlightListV2"
    },
    GetAirportCityList: {
        method: "post",
        module: "b2b",
        address: "Flight/GetAirportCityList"
    },
    SearchHotelDestinationList: {
        method: "post",
        module: "b2b",
        address: "Hotel/SearchHotelDestinationList"
    },
    GetTrainStationList: {
        method: "post",
        module: "b2b",
        address: "TrainTicket/GetTrainStationList"
    },
    GetPassengerList: {
        //获取用户常用联系人列表
        method: "post",
        module: "b2b",
        address: "Customer/GetPassengerList"
    },
    MaintainPassenger: {
        //增加用户常用联系人
        method: "post",
        module: "b2b",
        address: "Customer/MaintainPassenger"
    },
    GetPassengerInfo: {
        //获取单个常用联系人信息
        method: "post",
        module: "b2b",
        address: "Customer/GetPassengerInfo"
    },
    DeletePassenger: {
        //删除常用联系人
        method: "post",
        module: "b2b",
        address: "Customer/DeletePassenger"
    },
    GetCustomerIndexInfo: {
        //获取用户主页信息
        method: "post",
        module: "b2b",
        address: "Customer/GetCustomerIndexInfo"
    },
    GetOrderListInfo: {
        //获取订单列表
        method: "post",
        module: "b2b",
        address: "Order/GetOrderListInfoV2"
    },
    GetFlightOrderDetailV2: {
        //机票订单详情
        method: "post",
        module: "b2b",
        address: "Flight/GetFlightOrderDetailV2"
    },
    GetFlightSeatList: {
        //获取机票价格列表
        method: "post",
        module: "b2b",
        address: "Flight/GetFlightSeatList"
    },
    GetTrainDetail: {
        //获取火车票详情
        method: "post",
        module: "b2b",
        address: "TrainTicket/GetTrainDetail"
    },
    GetTrainList: {
        //获取机票价格列表
        method: "post",
        module: "b2b",
        address: "TrainTicket/GetTrainList"
    },
    getHotelList: {
        //获取酒店列表
        method: "post",
        module: "b2b",
        address: "Hotel/Search"
    },
    GetHotelDetailInfo: {
        //获取酒店详情
        method: "post",
        module: "b2b",
        address: "Hotel/GetHotelDetailInfo"
    },
    GetHotelMoreInfo: {
        //获取酒店详情2
        method: "post",
        module: "b2b",
        address: "Hotel/GetHotelMoreInfo"
    },
    GetRoomList: {
        //获取酒店房间列表
        method: "post",
        module: "b2b",
        address: "Hotel/GetRoomListV3"
    },
    SetCollectionHotel: {
        //收藏（取消收藏）酒店
        method: "post",
        module: "b2b",
        address: "Customer/SetCollectionHotel"
    },
    SearchPrompts: {
        //获取酒店关键字搜索下拉待选列表
        method: "post",
        module: "b2b",
        address: "Hotel/SearchPrompts"
    },
    GetHotelFilter: {
        //获取酒店关键字搜索下拉待选列表
        method: "post",
        module: "b2b",
        address: "Hotel/GetHotelFilter"
    },
    QueryMyTravelStandard: {
        //酒店下单前获取差标
        method: "post",
        module: "b2b",
        address: "Customer/QueryMyTravelStandard"
    },
    GetHotelOrderSubmitInfoV2: {
        //获取酒店创建订单信息
        method: "post",
        module: "b2b",
        address: "Order/GetHotelOrderSubmitInfoV2"
    },
    SubmitHotelOrderInfoV2: {
        //酒店提交创建订单
        method: "post",
        module: "b2b",
        address: "Order/SubmitHotelOrderInfoV2"
    },
    GetHotelOrderInfo: {
        //查看酒店订单详情
        method: "post",
        module: "b2b",
        address: "Order/GetHotelOrderInfo"
    },
    GetHotelOrderPriceV2: {
        //查看酒店费用明细
        method: "post",
        module: "b2b",
        address: "Order/GetHotelOrderPriceV2"
    },
    CancelHotelOrder: {
        //取消酒店订单
        method: "post",
        module: "b2b",
        address: "Order/CancelHotelOrder"
    },
    GetTrainOrderDetailV2: {
        //火车订单详情
        method: "post",
        module: "b2b",
        address: "TrainTicket/GetTrainOrderDetailV2"
    },
    CancelTrainOrder: {
        //取消火车票订单
        method: "post",
        module: "b2b",
        address: "TrainTicket/CancelTrainOrder"
    },
    CreateTrainOrder: {
        //创建火车票订单接口
        method: "post",
        module: "b2b",
        address: "TrainTicket/CreateTrainOrder"
    },
    GetTrainRefundInfo: {
        //获取退改规则接口
        method: "post",
        module: "b2b",
        address: "TrainTicket/GetTrainRefundInfo"
    },
    ApplyTrainOrderRefund: {
        //提交火车票退票申请
        method: "post",
        module: "b2b",
        address: "TrainTicket/ApplyTrainOrderRefund"
    },
    GetCarOrderDetail: {
        //查看用车订单详情
        method: "post",
        module: "b2b",
        address: "Car/GetCarOrderDetail"
    },
    GetServerPhone: {
        //获取客服电话
        method: "post",
        module: "b2b",
        address: "Order/GetServerPhone"
    },
    GetRefundAndModifyStipulate: {
        //获取退改签规则
        method: "post",
        module: "b2b",
        address: "Flight/GetRefundAndModifyStipulate"
    },
    GetBaggageruleAndRefundModifyStipulate: {
        //获取最新退改签规则
        method: "post",
        module: "b2b",
        address: "Flight/GetBaggageruleAndRefundModifyStipulate"
    },
    CheckFlightStandard: {
        method: "post",
        module: "b2b",
        address: "Flight/CheckFlightStandard"
    },
    ValidateFlightOrder: {
        //校验下单的舱位及价格
        method: "post",
        module: "b2b",
        address: "Flight/ValidateFlightOrder"
    },
    GetFlightOrderSubmitInfo: {
        //机票创建订单获取信息接口
        method: "post",
        module: "b2b",
        address: "Flight/GetFlightOrderSubmitInfo"
    },
    CheckTrainStandard: {
        //校验火车票
        method: "post",
        module: "b2b",
        address: "TrainTicket/CheckTrainStandard"
    },
    GetTrainOrderSubmit: {
        //火车票创建订单获取信息接口
        method: "post",
        module: "b2b",
        address: "TrainTicket/GetTrainOrderSubmit"
    },
    GetOrderPayInfo: {
        //获取支付信息
        method: "post",
        module: "b2b",
        address: "Order/GetOrderPayInfo"
    },
    GetReturnFlightOrderSubmitInfo: {
        //获取创建订单信息
        method: "post",
        module: "b2b",
        address: "Flight/GetReturnFlightOrderSubmitInfo"
    },
    CreateFlightOrder: {
        //创建订单
        method: "post",
        module: "b2b",
        address: "Flight/CreateFlightOrder"
    },
    CreateReturnFlightOrder: {
        //创建往返机票订单
        method: "post",
        module: "b2b",
        address: "Flight/CreateReturnFlightOrder"
    },
    GetPayInfoByPayType: {
        //支付接口
        method: "post",
        module: "b2b",
        address: "Common/GetPayInfoByPayType"
    },
    GetApproverOrderNum: {
        //支付相关
        method: "post",
        module: "b2b",
        address: "Customer/GetApproverOrderNum"
    },
    CheckPayResult: {
        //查询支付结果
        method: "post",
        module: "b2b",
        address: "Payment/CheckPayResult"
    },
    CancelFlightOrder: {
        //取消机票订单
        method: "post",
        module: "b2b",
        address: "Flight/CancelFlightOrder"
    },
    QueryRoleConfigList: {
        //获取差标列表
        method: "post",
        module: "b2b",
        address: "Customer/QueryRoleConfigList"
    },
    QueryRoleConfigDetail: {
        //编辑单个差标信息
        method: "post",
        module: "b2b",
        address: "Customer/QueryRoleConfigDetail"
    },
    GetRoleEnumInitialize: {
        //获取编辑差标下拉信息
        method: "post",
        module: "b2b",
        address: "Customer/GetRoleEnumInitialize"
    },
    MaintainRoleConfig: {
        //保存差标
        method: "post",
        module: "b2b",
        address: "Customer/MaintainRoleConfig"
    },
    ApprovalTravelBusinessOrder: {
        //提交审批订单
        method: "post",
        module: "b2b",
        address: "TMC/ApprovalTravelBusinessOrder"
    },
    GetFlightOrderDetail: {
        //我的审批-机票详情
        method: "post",
        module: "b2b",
        address: "TMC/GetFlightOrderDetail"
    },
    approvalHotelOrderInfo: {
        //我的审批-机票详情
        method: "post",
        module: "b2b",
        address: "TMC/GetHotelOrderInfo"
    },
    GetTrainOrderDetail: {
        //我的审批-火车票详情
        method: "post",
        module: "b2b",
        address: "TMC/GetTrainOrderDetail"
    },
    GetRechargeTips: {
        //获取充值信息（支付方式列表，面值列表等）
        method: "post",
        module: "b2b",
        address: "Customer/GetRechargeTips"
    },
    RechargeOffline: {
        //线下充值
        method: "post",
        module: "b2b",
        address: "Customer/RechargeOffline"
    },
    GetDaliyReminderOrderInfo: {
        //获取带出行信息
        method: "post",
        module: "b2b",
        address: "Customer/GetDaliyReminderOrderInfo"
    },
    GetCollectionHotelList: {
        //获取带出行信息
        method: "post",
        module: "b2b",
        address: "Customer/GetCollectionHotelList"
    },
    EditPassword: {
        //修改密码
        method: "post",
        module: "b2b",
        address: "Customer/EditPassword"
    },
    GetApproveOrderList: {
        //获取待/已审核订单
        method: "post",
        module: "b2b",
        address: "TMC/GetApproveOrderList"
    },
    GetOverStandardReson: {
        //获取超标理由
        method: "post",
        module: "b2b",
        address: "Order/GetOverStandardReson"
    },
    GetPassengersAndReasons: {
        //获取乘客列表和退改原因接口
        method: "post",
        module: "b2b",
        address: "Flight/GetOrderInfosForChangeAndRefund"
    },
    FlightPassengersModify: {
        //机票 提交修改乘客
        method: "post",
        module: "b2b",
        address: "Flight/FlightPassengersModify"
    },
    TrainGetChangePassengerInfo: {
        //获取火车票改签乘客信息
        method: "post",
        module: "b2b",
        address: "TrainTicket/GetChangePassengerInfo"
    },
    GetRefundTicketCostInfo: {
        //获取退票费用接口
        method: "post",
        module: "b2b",
        address: "Flight/GetRefundTicketCostInfo"
    },
    GetDepartmentList: {
        //获取部门列表
        method: "post",
        module: "b2b",
        address: "Customer/GetDepartmentList"
    },
    GetCustomerStuffList: {
        //获取指定部门的员工列表
        method: "post",
        module: "b2b",
        address: "Customer/GetCustomerStuffList"
    },
    ApplyFlightOrderRefund: {
        //提交机票退票信息
        method: "post",
        module: "b2b",
        address: "Flight/ApplyFlightOrderRefund"
    },
    GetFlightOrderChange: {
        //获取机票日期改签订单提交信息
        method: "post",
        module: "b2b",
        address: "Flight/GetFlightOrderChange"
    },
    ChangeFlightOrder: {
        //提交机票日期改签
        method: "post",
        module: "b2b",
        address: "Flight/ChangeFlightOrder"
    },
    GetChangeFlightList: {
        //获取改签航班数据
        method: "post",
        module: "b2b",
        address: "Flight/GetChangeFlightList"
    },
    GetTrainOrderChange: {
        //获取火车票改签订单提交信息
        method: "post",
        module: "b2b",
        address: "TrainTicket/GetTrainOrderChange"
    },
    GetDepartmentStuffInfo: {
        //查看员工差标信息
        method: "post",
        module: "b2b",
        address: "Customer/GetDepartmentStuffInfo"
    },
    DeleteEnterpriseStuff: {
        //删除员工
        method: "post",
        module: "b2b",
        address: "Customer/DeleteEnterpriseStuff"
    },
    MaintainDepartmentStuff: {
        //添加（编辑）员工
        method: "post",
        module: "b2b",
        address: "Customer/MaintainDepartmentStuff"
    },
    SearchStuffAndDepartment: {
        //搜索部门、员工
        method: "post",
        module: "b2b",
        address: "Customer/SearchStuffAndDepartment"
    },
    GetDepartmentInfo: {
        method: "post",
        module: "b2b",
        address: "Customer/GetDepartmentInfo"
    },
    MaintainDepartment: {
        //添加（编辑）部门
        method: "post",
        module: "b2b",
        address: "Customer/MaintainDepartment"
    },
    DepartmentDelete: {
        //删除部门
        method: "post",
        module: "b2b",
        address: "Customer/DepartmentDelete"
    },
    GetTransferEnterpriseStuffList: {
        //获取所有员工（转移管理员）
        method: "post",
        module: "b2b",
        address: "Customer/GetTransferEnterpriseStuffList"
    },
    TransferEnterpriseManager: {
        //获取所有员工（转移管理员）
        method: "post",
        module: "b2b",
        address: "Customer/TransferEnterpriseManager"
    },
    ChangeTrainOrder: {
        //火车票订单改签提交
        method: "post",
        module: "b2b",
        address: "TrainTicket/ChangeTrainOrder"
    },
    MakeQRCode: {
        //获取微信支付二维码
        method: "post",
        module: "b2b",
        address: "Common/MakeQRCode/ChangeTrainOrder"
    },
    AvailHotelBooking: {
        //获取酒店可定房间数
        method: "post",
        module: "b2b",
        address: "Order/AvailHotelBooking"
    },
    GetNationalityDataList: {
        //获取国籍列表
        method: "post",
        module: "b2b",
        address: "common/GetNationalityDataList"
    },
    GetIdentityTypeList: {
        //获取证件类型列表
        method: "post",
        module: "b2b",
        address: "common/GetIdentityTypeList"
    },
    GetSummaryStatistics: {
        //获取账单统计
        method: "post",
        module: "b2b",
        address: "Statistics/GetSummaryStatistics"
    },
    GetBillDetails: {
        //获取账单明细
        method: "post",
        module: "b2b",
        address: "Statistics/GetBillDetails"
    },
    GetBillDetailsV2: {
        //获取账单明细(新接口)
        method: "post",
        module: "b2b",
        address: "Statistics/GetBillDetailsV2"
    },
    GetEnterpriseSurvey: {
        //获取企业信息
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseSurvey"
    },
    GetEnterpriseRoleSurvey: {
        //获取差标名称
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseRoleSurvey"
    },
    GetEnterpriseStuffList: {
        //获取不同类型的员工
        method: "post",
        module: "b2b",
        address: "Customer/GetEnterpriseStuffList"
    },
    GetEnterpriseContractSurvey: {
        //获取企业合作信息
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseContractSurvey"
    },
    GetEnterpriseSettleSurvey: {
        //获取企业结算信息
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseSettleSurvey"
    },
    GetEnterpriseCostSurvey: {
        //获取企业消费概况
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseCostSurvey"
    },
    GetCustomerApplyList: {
        //获取审核员工列表
        method: "post",
        module: "b2b",
        address: "Customer/GetCustomerApplyList"
    },
    ApproveCustomerApply: {
        //审核员工
        method: "post",
        module: "b2b",
        address: "Customer/ApproveCustomerApply"
    },
    UploadImage: {
        //上传图片
        method: "post",
        module: "b2b",
        address: "Common/UploadImage"
    },
    GetEnterpriseCertify: {
        //获取资质接口
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseCertify"
    },
    MaintainEnterpriseCertify: {
        //新增编辑资质接口
        method: "post",
        module: "b2b",
        address: "Enterprise/MaintainEnterpriseCertify"
    },
    DeleteEnterpriseCertify: {
        //删除资质接口
        method: "post",
        module: "b2b",
        address: "Enterprise/DeleteEnterpriseCertify"
    },
    GetInvoiceTitleInfo: {
        //发票抬头查询
        method: "post",
        module: "b2b",
        address: "Customer/GetInvoiceTitleInfo"
    },
    SubmitInvoiceTitleInfo: {
        //发票抬头提交
        method: "post",
        module: "b2b",
        address: "Customer/SubmitInvoiceTitleInfo"
    },
    DelInvoiceTitleInfo: {
        //发票抬头删除
        method: "post",
        module: "b2b",
        address: "Customer/DelInvoiceTitleInfo"
    },
    SubmitMailInfo: {
        //地址提交
        method: "post",
        module: "b2b",
        address: "Customer/SubmitMailInfo"
    },
    DelMailInfo: {
        //地址删除
        method: "post",
        module: "b2b",
        address: "Customer/DelMailInfo"
    },
    GetMailInfo: {
        //地址查询
        method: "post",
        module: "b2b",
        address: "Customer/GetMailInfo"
    },
    GetEnterpriseExternal: {
        //获取企业拓展信息
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseExternal"
    },
    GetAreaList: {
        //获取省市区
        method: "post",
        module: "b2b",
        address: "Common/GetAreaList"
    },
    MaintainEnterpriseBudget: {
        //新增、编辑预算
        method: "post",
        module: "b2b",
        address: "Enterprise/MaintainEnterpriseBudget"
    },
    DeleteEnterpriseBudget: {
        //新增预算
        method: "post",
        module: "b2b",
        address: "Enterprise/DeleteEnterpriseBudget"
    },
    GetEnterpriseBudget: {
        //获取预算模板
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseBudget"
    },
    GetEnterpriseBudgetList: {
        //获取预算列表
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseBudgetList"
    },
    GetEnterpriseBudgetCost: {
        //获取预算消费
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseBudgetCost"
    },
    GetExpensesList: {
        //报销单列表
        method: "post",
        module: "b2b",
        address: "Customer/GetExpensesList"
    },
    GetExpensesDetail: {
        method: "post",
        module: "b2b",
        address: "Customer/GetExpensesDetail"
    },
    GetProjectList: {
        //获取项目中心列表
        method: "post",
        module: "b2b",
        address: "Customer/GetProjectList"
    },
    MaintainProject: {
        //新增编辑项目
        method: "post",
        module: "b2b",
        address: "Customer/MaintainProject"
    },
    DeleteProject: {
        //删除项目
        method: "post",
        module: "b2b",
        address: "Customer/DeleteProject"
    },
    GetProjectMemberList: {
        //获取项目成员
        method: "post",
        module: "b2b",
        address: "Customer/GetProjectMemberList"
    },
    AddProjectMember: {
        //添加项目成员
        method: "post",
        module: "b2b",
        address: "Customer/AddProjectMember"
    },
    DeleteProjectMember: {
        //删除项目成员
        method: "post",
        module: "b2b",
        address: "Customer/DeleteProjectMember"
    },
    GetMyCostCenter: {
        //我的成本中心
        method: "post",
        module: "b2b",
        address: "Customer/GetMyCostCenter"
    },
    GetSystemTime: {
        //获取当前时间
        method: "post",
        module: "b2b",
        address: "Common/GetSystemTime"
    },
    GetCostTypeList: {
        //获取费用类型列表
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetCostTypeList"
    },
    SaveCustomerCostType: {
        //保存费用类型
        method: "post",
        module: "b2b",
        address: "CustomerBill/SaveCustomerCostType"
    },
    DeleteCustomerCostType: {
        //删除费用类型
        method: "post",
        module: "b2b",
        address: "CustomerBill/DeleteCustomerCostType"
    },
    GetBillList: {
        //获取单据列表
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetBillList"
    },
    GetApplyBillStatistics: {
        //获取日常单据统计信息
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetApplyBillStatistics"
    },
    GetLoanBillStatistics: {
        //获取借款单据统计信息
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetLoanBillStatistics"
    },
    GetReimbursementBillStatistics: {
        //获取报销单据统计信息
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetReimbursementBillStatistics"
    },
    GetDailyApplyBillDetail: {
        //获取日常申请单详情
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetDailyApplyBillDetail"
    },
    GetTravelApplyBillDetail: {
        //获取出差申请单详情
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetTravelApplyBillDetail"
    },
    GetLoanApplyBillDetail: {
        //获取借款单详情
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetLoanApplyBillDetail"
    },
    GetReimbursementBillDetail: {
        //获取报销单详情
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetReimbursementBillDetail"
    },
    BillMakeMoney: {
        //打款
        method: "post",
        module: "b2b",
        address: "CustomerBill/BillMakeMoney"
    },
    BillsMakeMoney: {
        //批量打款
        method: "post",
        module: "b2b",
        address: "CustomerBill/BillsMakeMoney"
    },
    GetEnterpriseCostReport: {
        //获取报告单
        method: "post",
        module: "b2b",
        address: "Enterprise/GetEnterpriseCostReport"
    },
    ApplyBusinessTravelExperienceAccount: {
        //提交申请
        method: "post",
        module: "b2b",
        address: "Customer/ApplyBusinessTravelExperienceAccount"
    },
    UpdateCostTypeByReimbursementBill: {
        //修改费用状态
        method: "post",
        module: "b2b",
        address: "CustomerBill/UpdateCostTypeByReimbursementBill"
    },
    GetJsApiConfig: {
        //获取企业配置
        method: "post",
        module: "b2b",
        address: "oa/GetJsApiConfig"
    },
    GetCustomerIdList: {
        //获取用户Id列表
        method: "post",
        module: "b2b",
        address: "Customer/GetCustomerIdList"
    },
    UpdateCostTypeByReimbursementBill: {
        //修改费用状态
        method: "post",
        module: "b2b",
        address: "CustomerBill/UpdateCostTypeByReimbursementBill"
    },
    ApprovalBill: {
        //审批单据
        method: "post",
        module: "b2b",
        address: "CustomerBill/ApprovalBill"
    },
    UpdateCostDeductionByReimbursementBill: {
        //修改费用发票是否能抵扣
        method: "post",
        module: "b2b",
        address: "CustomerBill/UpdateCostDeductionByReimbursementBill"
    },
    GetCustomerInfo: {
        method: "post",
        module: "b2b",
        address: "Customer/GetCustomerInfo"
    },
    UploadFile: {
        // 上传文件
        method: "post",
        module: "b2b",
        address: "Common/UploadFile"
    },
    EditBillFile: {
        // 编辑单据文件
        method: "post",
        module: "b2b",
        address: "CustomerBill/EditBillFile"
    },
    GetNewReimbursementBillDetail: {
        // 新版获取报销单详情
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetNewReimbursementBillDetail"
    },
    GetLoginUrl: {
        // 获取钉钉登录地址
        method: "post",
        module: "b2b",
        address: "Customer/GetLoginUrl"
    },
    DeletePayerInfo: {
        // 删除付款单位
        method: "post",
        module: "b2b",
        address: "CustomerBill/DeletePayerInfo"
    },
    GetPayerList: {
        // 获取付款单位列表
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetPayerList"
    },
    SavePayerInfo: {
        // 保存付款单位
        method: "post",
        module: "b2b",
        address: "CustomerBill/SavePayerInfo"
    },
    GetBankList: {
        // 获取银行列表
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetBankList"
    },
    GetBillPresonalAccountListPage: {
        // 获取往来单位列表
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetBillPresonalAccountListPage"
    },
    SaveBillPersonalAccountInfo: {
        // 保存往来单位
        method: "post",
        module: "b2b",
        address: "CustomerBill/SaveBillPersonalAccountInfo"
    },
    DeleteBillPersonalAccountInfo: {
        // 保存往来单位
        method: "post",
        module: "b2b",
        address: "CustomerBill/DeleteBillPersonalAccountInfo"
    },
    GetProvinceList: {
        // 获取省份列表
        method: "post",
        module: "b2b",
        address: "Common/GetProvinceList"
    },
    GetCityList: {
        // 获取省份列表
        method: "post",
        module: "b2b",
        address: "Common/GetCityList"
    },
    GetPaymentBillDetail: {
        // 获取付款单详情
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetPaymentBillDetail"
    },
    GetPayerListAll: {
        // 获取所有付款单位
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetPayerListAll"
    },
    GetPaymentBillStatistics: {
        // 获取付款单统计
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetPaymentBillStatistics"
    },
    GetCorporateReimbursementBillDetail: {
        // 获取对公打款报销单详情
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetCorporateReimbursementBillDetail"
    },
    GetCorporateReimbursementBillStatistics: {
        // 获取对公打款统计信息
        method: "post",
        module: "b2b",
        address: "CustomerBill/GetCorporateReimbursementBillStatistics"
    },
    GetTravelSubsidyDetail: {
        // 获取差补列表
        method: "post",
        module: "b2b",
        address: "Statistics/GetTravelSubsidyDetail"
    },
    GetJsApiConfig: {
        // 获取jsconfig配置
        method: "post",
        module: "b2b",
        address: "oa/GetJsApiConfig"
    },
    MaintainDepartmentStuffWorkPlace: {
        // 编辑工作地
        method: "post",
        module: "b2b",
        address: "Customer/MaintainDepartmentStuffWorkPlace"
    },
    OrganizationFileImport: {
        // 导入文件
        method: "post",
        module: "b2b",
        address: "Common/OrganizationFileImport"
    },
    WorkPlaceImport: {
        // 导入工作地文件
        method: "post",
        module: "b2b",
        address: "Common/ImportCustomerStuffWorkPlace"
    },
    GetPublicConfigValue: {
        // 根据KEY获取配置
        method: "post",
        module: "b2b",
        address: "Common/GetPublicConfigValue"
    },
    ImportAppointApprover: {
        //批量导入直接审批人
        method: "post",
        module: "b2b",
        address: "Common/ImportAppointApprover"
    },
    ImportCityGroupFile: {
        // 导入酒店差标分组批量城市
        method: "post",
        module: "b2b",
        address: "Common/ImportCityGroupFile"
    },
    GetRoomArrangements: {
        // 获取房间入住人列表
        method: "post",
        module: "b2b",
        address: "Hotel/GetRoomArrangements"
    },
    SaveList: {
        // 添加入住人
        method: "post",
        module: "b2b",
        // address: "Hotel/roomArrangement/SaveList"
        address: "Hotel/SaveArrangements"
    },
    GetRoomArrangementConfig: {
        // 添加入住人
        method: "post",
        module: "b2b",
        address: "Hotel/GetRoomArrangementConfig "
    },
    OpenChildEnterpriseFromDepartment: {
        // 设置子公司
        method: "post",
        module: "b2b",
        address: "Customer/OpenChildEnterpriseFromDepartment"
    },
    GetSyncButtonInfo: { //同步人员按钮状态
        method: "post",
        module: "b2b",
        address: "Enterprise/GetSyncButtonInfo"
    },
    SyncDepartmentsAndMemberInfos: { //同步人员按钮
        method: "post",
        module: "b2b",
        address: "Enterprise/SyncDepartmentsAndMemberInfos"
    }
}

exports.b2bApi = b2bApi;